import React from "react";
import { motion } from "framer-motion";
import AboutInner from "../../../src/assets/new-images/about-inner-1.png";
import PortfolioDetails from "../../../src/assets/new-images/Group.jpeg";

const FounderSection = () => {
  return (
    <section className="about_us_founder_section">
      <div className="about_us_founder_section__container">
        <div className="about_us_founder_section__grid">
          {/* Left Column - Text Content */}
          <div className="about_us_founder_section__content">
            <div>
              <h2 className="about_us_founder_section__title">
                Built by founders who lived the chaos.
              </h2>
              <p className="about_us_founder_section__text about_us_founder_section__text--mb">
                Before Simplifyte, Aamir and Gautam ran operations for
                fast-growing professional service firms. They spent years trying
                to patch together disparate tools—chat apps, spreadsheets,
                generic task managers—only to realize the core problem wasn't a
                lack of software, but a lack of connection.
              </p>
              <p className="about_us_founder_section__text">
                They built Simplifyte to be the platform they wished they had: a
                calm, unified workspace where every click has a purpose and
                nothing gets lost.
              </p>
            </div>

            {/* Quote Block */}
            <div className="about_us_founder_section__quote">
              <svg
                className="about_us_founder_section__quote_icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
                <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
              </svg>
              <p className="about_us_founder_section__quote_text">
                “We built Simplifyte for teams that cannot afford operational
                chaos.”
              </p>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="about_us_founder_section__image_wrapper">
            <div className="about_us_founder_section__image_overlay"></div>
            <img
              src={AboutInner}
              alt="Founders of Simplifyte - Aamir Dholia and Gautam Parmar"
              className="about_us_founder_section__image"
            />
            <div className="about_us_founder_section__image_caption">
              <p className="about_us_founder_section__caption_name">
                Aamir Dholia & Gautam Parmar
              </p>
              <p className="about_us_founder_section__caption_role">
                Co-founders, Simplifyte
              </p>
            </div>
          </div>
        </div>
        <div className="Simplifyte_Team">
          <h1 className="about_us_founder_section__title text-center">
            The people behind the calm.
          </h1>
          <p className="about_us_founder_section__text_Team">
            Built by people who understand the pressure behind professional
            work.
          </p>
          <p className="about_us_founder_section__text_Team_Para">
            At Simplifyte, we’re not just builders — we’re former operators who
            have felt the weight of broken workflows, missed deadlines,
            scattered files, and endless notifications. That experience shapes
            everything we build: less noise, more clarity, and a workspace that
            helps your team focus on what truly matters.
          </p>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.03,
              y: -1,
              boxShadow: "0 8px 2px rgba(0,0,0,0.2)",
            }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="portfolio-details-thumb shadow rounded-2xl mt-20"
          >
            <img
              src={PortfolioDetails}
              alt="Simplifyte"
              className="rounded-2xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
